<template>
	<v-container>
		<v-card class="shadowCard">
			<v-card-title primary-title>
			  <span class="text-caption">Datos personales</span>
			</v-card-title>
			<v-card-text>
			  
				<v-form
			    ref="form"
			    v-model="valid"
			    lazy-validation
			  >
			  	<v-row>
			  		<v-col cols="12" class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.nombre_completo"
					      :rules="[rules.required]"
					      label="Nombre"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
			  		</v-col>

						<v-col cols="6"  class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.edad"
					      :rules="[rules.required]"
					      label="Edad"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6" class="pb-0">
							<v-text-field
					    	:disabled="disabled"
					      v-model="perfil.telefono"
					      :rules="[rules.required]"
					      label="Teléfono"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>
			  	</v-row>
			  </v-form>
			</v-card-text>

		  <v-card-actions class="mt-4">
		    <v-btn
		    	v-if="modoVista == 1"
		      color="primary"
		      class="text-capitalize px-6"
		      @click="dialogConfirma = true"
		      rounded
		      text
		    >
		      Eliminar cuenta
		    </v-btn>
		    <v-spacer></v-spacer>
		    <v-btn
		    	v-if="modoVista == 1"
		      color="primary"
		      class="text-capitalize px-6"
		      @click="disabled = false, modoVista = 2"
		      rounded
		    >
		      Editar
		    </v-btn>

		    <v-btn
		    	v-else
		      color="primary"
		      class="text-capitalize px-6"
		      @click="validarUsuario()"
		      rounded
		    >
		      Guardar
		    </v-btn>
		  </v-card-actions>
		</v-card>

		<!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogConfirma" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				¿Estás seguro que deseas eliminar tus datos de la aplicación?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="dialogConfirma = false">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

		<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

  	props:[
			'perfil'
	  ],

    data: () => ({
    	// Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

    	modoVista: 1, // 1-. Editar, 2-. Guardar
    	disabled: true,
      valid: true,
    	
    	// Datos del usuario
    	usuario:'',
    	password:'',

      showPassword: true,
      rules: {
        required: value => !!value || 'Requerido.'
      },

      respuestaAlerta: false,
      success:false,
      parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	loader: true,
      cargar: false,

      dialogConfirma: false
    }),

    computed:{
    	...mapGetters( 'login', [ 'getdatosUsuarioFitHouse']),

    },

    methods: {
      ...mapActions('login',['salirLogin']),


      validarDatos () {
        return this.$refs.form.validate()
      },

      validarUsuario (){
      	this.cargar = true
      	if( this.validarDatos() ){
      		// validar los datos del usuario
	      	this.$http.post('usuario.update.datos', this.perfil).then( response => {
	      		this.cargar = false
	      		this.validarSuccess('Datos grabados correctamente')
      			this.disabled  = true
      			this.modoVista = 1
	      	}).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
      	}
      },

      deleteItemConfirm( ){
      	// validar los datos del usuario
      	this.$http.post('usuario.update.delete', this.perfil).then( response => {
      		this.cargar = false
      		this.validarSuccess('Datos grabados correctamente')
    			this.disabled  = true
    			this.dialogConfirma = false
    			this.salirLogin()
        	this.$router.push({name:'Login'})
      	}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      }
    },
  }
</script>
<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

</style>